export default {
    replacementProduct: '',
    selectedCurtains:'',
    curtainArea:'',
    replacementProducts:'',
    replacementProductPrice:0,
    replacementStripLengthInc:0,
    replacementStripLengthFeet:0,
    replacementStripQty:0,
    replacementProductCode:'',
    fourInchIengths:{
        low:60,
        heigh:108,
        type:"4 INCH"
    },
    sixInchIengths:{
        low:60,
        heigh:126,
        type:"6 INCH"
    },
    eightInchIengths:{
        low:60,
        heigh:132,
        type:"8 INCH"
    },
    stripLengthValidationMsg:false,
    stripReplacementType:''
}